var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconCompare = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1 4C1 2.89543 1.89543 2 3 2H9C10.1046 2 11 2.89543 11 4V20C11 21.1046 10.1046 22 9 22H3C1.89543 22 1 21.1046 1 20V4ZM3 4V20H9V4H3Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21 19V20H20C19.4477 20 19 20.4477 19 21C19 21.5523 19.4477 22 20 22H21C22.1046 22 23 21.1046 23 20V19C23 18.4477 22.5523 18 22 18C21.4477 18 21 18.4477 21 19Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21 5V4H20C19.4477 4 19 3.55228 19 3C19 2.44772 19.4477 2 20 2L21 2C22.1046 2 23 2.89543 23 4V5C23 5.55228 22.5523 6 22 6C21.4477 6 21 5.55228 21 5Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 19V20H16C16.5523 20 17 20.4477 17 21C17 21.5523 16.5523 22 16 22H15C13.8954 22 13 21.1046 13 20V19C13 18.4477 13.4477 18 14 18C14.5523 18 15 18.4477 15 19Z",
    fill: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 5V4H16C16.5523 4 17 3.55228 17 3C17 2.44772 16.5523 2 16 2L15 2C13.8954 2 13 2.89543 13 4V5C13 5.55228 13.4477 6 14 6C14.5523 6 15 5.55228 15 5Z",
    fill: "currentColor"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22 7C22.5523 7 23 7.44772 23 8V10C23 10.5523 22.5523 11 22 11C21.4477 11 21 10.5523 21 10V8C21 7.44772 21.4477 7 22 7Z",
    fill: "currentColor"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22 13C22.5523 13 23 13.4477 23 14V16C23 16.5523 22.5523 17 22 17C21.4477 17 21 16.5523 21 16V14C21 13.4477 21.4477 13 22 13Z",
    fill: "currentColor"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14 7C14.5523 7 15 7.44772 15 8V10C15 10.5523 14.5523 11 14 11C13.4477 11 13 10.5523 13 10V8C13 7.44772 13.4477 7 14 7Z",
    fill: "currentColor"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14 13C14.5523 13 15 13.4477 15 14V16C15 16.5523 14.5523 17 14 17C13.4477 17 13 16.5523 13 16V14C13 13.4477 13.4477 13 14 13Z",
    fill: "currentColor"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconCompare);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "media/IconCompare.1263fda6aaf2b22a41529f60c6b727cc.svg";